export default "__VITE_ASSET__p71mgdGt__"